import { PlankPatternForm } from "./PlankPattern.form";

/** One tile photo is enough; the generator reads the tile's proportions and which way it faces. */
export const ArrowPatternForm = (props) => (
  <PlankPatternForm
    {...props}
    pattern="arrow"
    width={{ value: "5", min: 2, max: 20, labelKey: "TILE_WIDTH" }}
    height={{ value: "25", min: 10, max: 60, labelKey: "TILE_HEIGHT" }}
  />
);
